import React, { memo } from 'react';
import type { AccessRef } from 'lib/LobbyEntities';
import BaseRowList from 'components/RowList';
import Builder, { type Mapping } from '../../../../../../../Builder';

interface SoleOfferProps {
  offer: AccessRef;
  mapping: Mapping;
}

const SoleOffer = ({ offer, mapping }: SoleOfferProps) => (
  <BaseRowList className="dynamicLobby__rowListContent">
    <Builder accessRef={offer.__access} mapping={mapping} />
  </BaseRowList>
);

export default memo(SoleOffer);
